module.exports = __webpack_public_path__ + "static/media/lock_active.7881f048.svg";